<template>
  <!-- post弹框 -->
  <a-modal
    v-model="showPostSuccessModal"
    title=""
    :centered="true"
    :footer="null"
    :maskClosable="false"
    dialogClass="global-campaign-post-success-modal-class"
    :closable="false"
  >
    <div class="post-success-con" :class="[lang]">
      <svg-icon
        iconClass="right"
        class="post-success-icon"
      ></svg-icon>
      <div class="post-success-title">{{ $t('successModalTitle') }}</div>
      <div class="post-success-txt">{{ $t('successModalTxt') }}</div>
    </div>
  </a-modal>
</template>

<script>
import { mapState } from "vuex";
import Bus from '@/utils/bus';

export default {
  props: {
    showModal: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      duration: 6000,
      showPostSuccessModal: false,
    }
  },
  i18n: {
    messages: {
      CN: {
        successModalTitle: '分享权限已激活',
        successModalTxt: '任务已创建，Post已在 LinkedIn分享。您可以在活动详情页面查看完整的搜索结果。',
      },

      US: {
        successModalTitle: 'The posting benefits have been activated.',
      successModalTxt: 'The campaign has been successfully published, and the post is live on LinkedIn. You can view the full search results on the campaign details page.',
      },
      AR: {
        successModalTitle: 'تم تفعيل مزايا النشر.',
        successModalTxt: 'تم نشر الحملة بنجاح، والمنشور الآن مباشر على LinkedIn. يمكنك عرض نتائج البحث الكاملة على صفحة تفاصيل الحملة.',
      },
    },
  },
  computed: {
    ...mapState("setting", ["lang"]),
    visible: {
      get () {
        return this.showModal
      },
      set (val) {
        this.$emit('update:showModal', val)
      }
    }
  },
  created () {
    Bus.$on('showPostSuccessModal', () => {
      this.showPostModal();
    })
  },
  methods: {
    setTimer() {
      setTimeout(() => {
        this.showPostSuccessModal = false;
      }, this.duration);
    },
    showPostModal () {
      this.showPostSuccessModal = true;
      this.setTimer();
    },
  },
  beforeDestroy () {
    Bus.$off('showPostSuccessModal');
  }
}
</script>

<style lang="less" scoped>
.post-success-con {
  padding: 40px 108px;
  text-align: center;
  .post-success-icon {
    font-size: 44px;
  }
  .post-success-title {
    font-weight: bold;
    font-size: 20px;
    color: #1B776E;
    line-height: 22px;
    padding: 24px 0 22px;
  }
  .post-success-txt {
    font-weight: bold;
    font-size: 14px;
    color: #666666;
    line-height: 30px;
  }
}
</style>
<style lang="less">
.global-campaign-post-success-modal-class {
  z-index: 10000;
  width: 900px !important;
  .ant-modal-body {
    padding: 0;
    position: relative;
  }
  .ant-modal-close {
    right: -4px;
    top: -2px;
  }
}
</style>
